/**
 * @generated SignedSource<<d73ebac139b668586042354a0ddf4f57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useLegalDocumentQueriesCurrentQuery$variables = {
  documentType: string;
  locale: string;
  systemId: string;
};
export type useLegalDocumentQueriesCurrentQuery$data = {
  readonly currentLegalDocument: {
    readonly documentType: string;
    readonly effectiveFrom: any;
    readonly id: string;
    readonly locale: string;
    readonly organizationId: string | null | undefined;
    readonly systemId: string | null | undefined;
    readonly textContent: string;
    readonly version: string;
  } | null | undefined;
};
export type useLegalDocumentQueriesCurrentQuery = {
  response: useLegalDocumentQueriesCurrentQuery$data;
  variables: useLegalDocumentQueriesCurrentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "documentType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "systemId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentType",
        "variableName": "documentType"
      },
      {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
      },
      {
        "kind": "Variable",
        "name": "systemId",
        "variableName": "systemId"
      }
    ],
    "concreteType": "LegalDocument",
    "kind": "LinkedField",
    "name": "currentLegalDocument",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documentType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locale",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "effectiveFrom",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "textContent",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLegalDocumentQueriesCurrentQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLegalDocumentQueriesCurrentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93b4994fc29eab034ce2ff4d139f7e1f",
    "id": null,
    "metadata": {},
    "name": "useLegalDocumentQueriesCurrentQuery",
    "operationKind": "query",
    "text": "query useLegalDocumentQueriesCurrentQuery(\n  $documentType: String!\n  $locale: String!\n  $systemId: ID!\n) {\n  currentLegalDocument(documentType: $documentType, locale: $locale, systemId: $systemId) {\n    id\n    documentType\n    locale\n    version\n    systemId\n    organizationId\n    effectiveFrom\n    textContent\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c8d8df2bacf9c93048936ca14c293dc";

export default node;
